import { Skeleton } from 'antd';
import { Row, Space } from 'farmhub-ui-core';

import { getDummyArray } from 'utils';

import { Hr, RowTableInfo, SkeletonWrapper } from './styles';

const K58BillSkeleton = () => (
  <div>
    <SkeletonWrapper>
      <Row justifyContent="center">
        <Skeleton.Input
          size="small"
          style={{ width: '100px', alignItems: 'center' }}
        />
      </Row>

      <Skeleton.Input
        size="small"
        style={{ width: '130px', alignItems: 'center' }}
      />
      <Skeleton.Input
        size="small"
        style={{ width: '130px', alignItems: 'center' }}
      />
    </SkeletonWrapper>
    <Hr type="dashed" />
    <SkeletonWrapper>
      <Row justifyContent="center">
        <Skeleton.Input
          size="small"
          style={{ width: '100px', alignItems: 'center' }}
        />
      </Row>
      <Row justifyContent="center">
        <Skeleton.Input
          size="small"
          style={{ width: '75px', alignItems: 'center' }}
        />
      </Row>
      <Space height={12} />
      <SkeletonWrapper>
        <Skeleton.Input style={{ width: 75, height: 75 }} />
      </SkeletonWrapper>
      <Space height={6} />
      <Skeleton.Input
        size="small"
        style={{ width: '75px', alignItems: 'center' }}
      />
      <Space height={12} />
      {getDummyArray(5).map(item => (
        <Row>
          <Skeleton.Input
            size="small"
            style={{ width: '50px', alignItems: 'center' }}
          />
          <Space width={12} />
          <Skeleton.Input
            size="small"
            style={{ width: '100px', alignItems: 'center' }}
          />
        </Row>
      ))}
      <Hr type="solid" />
      <RowTableInfo>
        <Row justifyContent="space-between">
          <Skeleton.Input
            size="small"
            style={{ width: '50px', alignItems: 'center' }}
          />
          <Space width={12} />
          <Skeleton.Input
            size="small"
            style={{ width: '50px', alignItems: 'center' }}
          />
          <Space width={12} />
          <Skeleton.Input
            size="small"
            style={{ width: '50px', alignItems: 'center' }}
          />
        </Row>
      </RowTableInfo>
      <Hr type="solid" />
      {getDummyArray(5).map(item => (
        <Row justifyContent="space-between">
          <Skeleton.Input
            size="small"
            style={{ width: '50px', alignItems: 'center' }}
          />
          <Skeleton.Input
            size="small"
            style={{ width: '50px', alignItems: 'center' }}
          />
          <Skeleton.Input
            size="small"
            style={{ width: '50px', alignItems: 'center' }}
          />
        </Row>
      ))}
      <Hr type="dashed" />
      {getDummyArray(4).map(item => (
        <Row justifyContent="space-between">
          <Skeleton.Input
            size="small"
            style={{ width: '50px', alignItems: 'center' }}
          />

          <Skeleton.Input
            size="small"
            style={{ width: '50px', alignItems: 'center' }}
          />
        </Row>
      ))}
      <Hr type="dashed" />
      <Row justifyContent="flex-start">
        <Skeleton.Input
          size="small"
          style={{ width: '50px', alignItems: 'center' }}
        />
      </Row>

      <Hr type="dashed" />
    </SkeletonWrapper>
  </div>
);

export default K58BillSkeleton;
